import { Warehouse } from '../types/Warehouse.types';

export const MOCK_WAREHOUSES: Warehouse[] = [
  {
    id: 'WH-01',
    name: 'Madrid Central Logístico',
    societyId: 'SOC-01',
    type: 'physical',
    managementModel: 'location',
    capacity: 50000,
    used: 38500,
    activeShipments: 12,
    address: 'Polígono Industrial San Fernando, Nave 12, Henares 28830',
    description: 'Almacén principal de distribución para la zona centro.'
  },
  {
    id: 'WH-02',
    name: 'Barcelona Distribución',
    societyId: 'SOC-02',
    type: 'physical',
    managementModel: 'product',
    capacity: 30000,
    used: 12000,
    activeShipments: 5,
    address: 'Zona Franca, Sector C, Barcelona 08040',
    description: 'Hub logístico para distribución en Cataluña y arco mediterráneo.'
  },
  {
    id: 'WH-03',
    name: 'Sevilla Distribución',
    societyId: 'SOC-01',
    type: 'physical',
    managementModel: 'hybrid',
    capacity: 15000,
    used: 14200,
    activeShipments: 8,
    address: 'Polígono PISA, Mairena del Aljarafe 41927'
  },
  {
    id: 'WH-04',
    name: 'Almacén Virtual E-Books',
    societyId: 'SOC-03',
    type: 'virtual',
    managementModel: 'product',
    capacity: 999999,
    used: 890,
    activeShipments: 0,
    description: 'Repositorio digital de e-books y contenidos electrónicos.'
  }
];
